import streamMedia from "./stream-media.js";
import streamErrorImage from "./stream-error-image.js";

export default {
	streamMedia,
	streamErrorImage,
};
